export class Property {
  /**
   * These 2 variables below are hard coded to check conditions.
   * @see manage-property.component.ts
   */
  static PROPERTY_FABRIC_AMOUNT = 'ZP';
  static PROPERTY_FABRIC_STOFVERRUIK = 'SV';

  static PROPERTY_AMOUNT = 'Amount';
  static PROPERTY_METERS = 'Meters';
  public id: number;
  public name: string;
  public code: string;
  public description: string;
  public status: string;
  public checked?: boolean;
  public amount?: number;

  public static getUnchangeableCodeProperties() {
    return [
      Property.PROPERTY_FABRIC_STOFVERRUIK,
      Property.PROPERTY_FABRIC_AMOUNT,
    ];
  }
}
